import React from 'react';
import {
  bool, string
} from 'prop-types';
import { AddToQuote } from '@thd-olt-component-react/add-to-quote';

export const BuyboxAddToQuote = ({
  itemId, fulfillmentLocation, fulfillmentMethod, quantity, disabled
}) => {

  return (
    <AddToQuote
      itemId={itemId}
      fulfillmentLocation={fulfillmentLocation}
      fulfillmentMethod={fulfillmentMethod}
      quantity={quantity}
      disabled={disabled}
    />
  );
};

BuyboxAddToQuote.defaultProps = {
  quantity: '1'
};

BuyboxAddToQuote.propTypes = {
  itemId: string.isRequired,
  fulfillmentLocation: string.isRequired,
  fulfillmentMethod: string.isRequired,
  quantity: string,
  disabled: bool.isRequired
};